import { RangeHorizon, ResampleIntervals } from '@chart';
import { useTranslation } from 'react-i18next';

export const useChartLocales = () => {
  //this is to prevent translations lazy loading when search modal is opened
  //ExchangeCard calls useTranslation(['countries', 'analyze'])
  //resulting in unmounting and remounting full DOM
  const { t } = useTranslation([
    'analyze',
    'countries',
    'scenarioCommander',
    'widget',
    'scenario',
    'screener',
    'insights',
    'chart',
    'common',
  ]);

  const menuBarLocales = {
    addData: t('chart:menuBar_addData'),
    marketLeadingIndicators: t('chart:menuBar_marketLeadingIndicators'),
    insights: t('chart:menuBar_insights'),
  };

  const horizonLocales = {
    [RangeHorizon.OneDay]: t('chart:intervals.horizon_OneDay'),
    [RangeHorizon.OneWeek]: t('chart:intervals.horizon_OneWeek'),
    [RangeHorizon.TwoWeeks]: t('chart:intervals.horizon_TwoWeeks'),
    [RangeHorizon.OneMonth]: t('chart:intervals.horizon_OneMonth'),
    [RangeHorizon.TwoMonths]: t('chart:intervals.horizon_TwoMonths'),
    [RangeHorizon.ThreeMonths]: t('chart:intervals.horizon_ThreeMonths'),
    [RangeHorizon.SixMonths]: t('chart:intervals.horizon_SixMonths'),
    [RangeHorizon.OneYear]: t('chart:intervals.horizon_OneYear'),
    [RangeHorizon.ThreeYears]: t('chart:intervals.horizon_ThreeYears'),
    [RangeHorizon.FiveYears]: t('chart:intervals.horizon_FiveYears'),
    [RangeHorizon.TenYears]: t('chart:intervals.horizon_TenYears'),
    [RangeHorizon.Max]: t('chart:intervals.horizon_Max'),
  };

  const resampleLocales = {
    [ResampleIntervals.OneMinute]: t('chart:intervals.resample_1m'),
    [ResampleIntervals.FiveMinutes]: t('chart:intervals.resample_5m'),
    [ResampleIntervals.FifteenMinutes]: t('chart:intervals.resample_15m'),
    [ResampleIntervals.ThirtyMinutes]: t('chart:intervals.resample_30m'),
    [ResampleIntervals.OneHour]: t('chart:intervals.resample_1h'),
    [ResampleIntervals.OneDay]: t('chart:intervals.resample_1D'),
    [ResampleIntervals.OneWeek]: t('chart:intervals.resample_1W'),
    [ResampleIntervals.OneMonth]: t('chart:intervals.resample_1M'),
  };

  const viewControllerLocales = {
    clearAllCharts: t('chart:clearAllCharts'),
    horizons: horizonLocales,
    resamples: resampleLocales,
  };

  return {
    menuBarLocales,
    horizonLocales,
    resampleLocales,
    viewControllerLocales,
  };
};
